import { z } from "zod/v4"
import ApiStatusError from "@/api/errors/ApiStatusError"

const maintenanceSchema = z.object({ umTime: z.string().optional() })

// Under maintenance the response also says when it ends (umTime), which the
// maintenance page shows while it re-queries init info.
export class SystemMaintenanceError extends ApiStatusError {
  readonly umTime: string | undefined

  constructor(error: ApiStatusError) {
    super({
      url: error.url,
      status: error.status,
      message: error.message,
      data: error.data
    })
    this.name = "SystemMaintenanceError"

    const body = maintenanceSchema.safeParse(error.data)
    this.umTime = body.success ? body.data.umTime : undefined
  }
}

export default SystemMaintenanceError
